// extracted by mini-css-extract-plugin
module.exports = {"container":"Verification_container__2zlkI"};